import { Injectable } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ShortcutsModalComponent } from "./shortcuts-modal.component";

@Injectable()
export class ShortcutsModalService {
  public modalOpen: boolean;
  private modalRef: NgbModalRef;
  constructor(private modalService: NgbModal) {}

  public toggle() {
    if (this.modalOpen) {
      this.modalRef.close();
      return;
    }

    this.modalRef = this.modalService.open(ShortcutsModalComponent);
    this.modalOpen = true;

    this.modalRef.result
      .then((_result: any) => {
        this.modalOpen = false;
      })
      .catch((_reason: any) => {
        this.modalOpen = false;
      });
  }
}
